import http from '@/utils/http';

/**
 * 修改密码
 */
export const pwd = (params: API.Auth.PwdParams) =>
  http.patch('/manager/password', params);

/**
 * 登出
 */
export const signOut = () => http.delete('/manager/auth');

/**
 * 登录
 */
export const signIn = (params: API.Auth.LoginParams) =>
  http.post<API.Auth.LoginResult>('/login', params);

export const getInfo = () => http.get<API.Auth.AuthInfo>('/getInfo');
